import React from 'react'
import styled, { keyframes } from 'styled-components'
import Slider from 'react-slick'
import 'node_modules/slick-carousel/slick/slick.css'
import 'node_modules/slick-carousel/slick/slick-theme.css'

const appear = keyframes`
    99% {
        visibility: hidden;
    }
    100% {
        visibility: visible;
    }
`

const disappear = keyframes`
    %99 {
        visibility: visible;
    }
    100% {
        visibility: hidden;
    }
`

const StyledSlider = styled(Slider)`
  .slick-track .slick-active.slick-current {
    animation: ${appear} 2s linear;
    animation-fill-mode: forwards;
  }
  .slick-active {
    margin: 0;
  }
  .slick-track .slick-slide {
    animation: ${disappear} 2s linear;
    animation-fill-mode: forwards;
    padding-left: 2px;
    padding-right: 2px;
  }
`

const SLIDER_SETTINGS = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  draggable: false,
  swipe: false,
  arrows: false,
  accessibility: false,
}

const SliderComponent = React.forwardRef(({ intialSlide = 0, children, ...rest }, ref) => (
  <StyledSlider {...SLIDER_SETTINGS} intialSlide={intialSlide} ref={ref} {...rest}>
    {children}
  </StyledSlider>
))

export default SliderComponent
